import axios from 'axios'
import { getDevConfig } from '@/devwars'

window.getCookie = function (name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

window.setCookie = function (name, value, minutes) {
  var expires = ''
  if (minutes) {
    var date = new Date()
    date.setTime(date.getTime() + minutes * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

axios.defaults.baseURL = '/sv-api'
if (window.prod) {
  axios.defaults.headers.common['PHPSESSID'] = window.getCookie('PHPSESSID')
  axios.interceptors.request.use((config) => {
    config.params = config.params || {}
    config.params['language'] = window.currentLanguage
    return config
  })
} else {
  const token = 'coral:coral'
  const encodedToken = btoa(token)
  axios.defaults.headers.common['Authorization'] = 'Basic ' + encodedToken
  const devConfig = getDevConfig()
  axios.defaults.params = {
    language: devConfig.language,
    fAuth: devConfig.fAuth,
  }
}

axios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(normalizeError(error))
)

if (window.orderSession) {
  axios.defaults.headers.orderSession = window.orderSession
}

// приходит из бэкенда с ошибкой 422 в POST /order
class ApiError extends String {
  constructor(message, { errorTitle, status } = {}) {
    super(message)
    this.errorTitle = errorTitle
    this.status = status
  }
}

function normalizeError(e) {
  console.error(e?.response?.data)
  return new ApiError(
    e?.response?.data?.error ??
      e?.response?.detail ??
      e?.response?.data?.detail ??
      'Unknown Error',
    {
      errorTitle: e?.response?.data?.errorTitle,
      status: e?.response?.status,
    }
  )
}

export default axios
